import api from '@/api'

const { $academic, $commission, $core } = api;

export const { $terms,  $careers } = $academic;
export const { $range, $sellers } = $commission;
export const { $users,  $countries, $citiesByState } = $core;

